import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'login';
}

export function GlassCard({ children, className, variant = 'default' }: GlassCardProps) {
  return (
    <div
      className={cn(
        'rounded-2xl',
        variant === 'default' && 'glass-card',
        variant === 'login' && 'glass-card-login',
        className
      )}
    >
      {children}
    </div>
  );
}
